export default "../../src/img/tex3.png";